// ═══════════════════════════════════════════════════════════════════════════════
// Helper — receipt detail banner when status is save (not yet in a settlement)
// ═══════════════════════════════════════════════════════════════════════════════

import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';

type HelperUnsettledReceiptBannerProps = {
  settlementsHref: string;
};

/** Amber CTA aligned with amber warning banner chrome (not generic primary). */
const AMBER_BANNER_CTA_CLASS =
  'inline-flex min-h-11 shrink-0 items-center justify-center rounded-xl bg-amber-700 px-4 py-2 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-amber-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 disabled:cursor-not-allowed disabled:opacity-60 dark:bg-amber-600 dark:hover:bg-amber-500';

export const HelperUnsettledReceiptBanner = ({
  settlementsHref,
}: HelperUnsettledReceiptBannerProps) => {
  const { t } = useLanguage();

  return (
    <div
      className="flex flex-col gap-3 rounded-xl border border-amber-100 bg-amber-50/90 p-3 dark:border-amber-900/40 dark:bg-amber-950/30 sm:flex-row sm:items-center sm:justify-between"
      role="note"
      aria-live="polite"
    >
      <div className="flex min-w-0 gap-3">
        <svg
          className="mt-0.5 h-5 w-5 shrink-0 text-amber-700 dark:text-amber-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8v4m0 4h.01M10.29 3.86l-8 14A1 1 0 003.16 19h17.68a1 1 0 00.87-1.5l-8-14a1 1 0 00-1.74 0z"
          />
        </svg>
        <p className="text-sm leading-relaxed text-amber-900 dark:text-amber-100/90">
          {t('receipt.detail.helperUnsettledBanner')}
        </p>
      </div>
      <Link
        to={settlementsHref}
        className={AMBER_BANNER_CTA_CLASS}
        aria-label={t('receipt.detail.helperUnsettledBannerCtaAria')}
        tabIndex={0}
      >
        {t('receipt.detail.helperUnsettledBannerCta')}
      </Link>
    </div>
  );
};
